import React, {useEffect, useState} from "react";
import Layout from "components/sales/layout/layout";
import localization from "assets/localization/localization";
import MapWithAMakredInfoWindow from "components/mapWithAMarker";
import Config from "services/config/config";

const SitesLocationMap = ({fetchSitesLocationMap, sitesLocMapList}) => {
    const [isLoading, setIsLoading] = useState(false);

    useEffect(()=> {
        (async()=> {
            setIsLoading(true)
            await fetchSitesLocationMap()
            setIsLoading(false)
        })();
    }, [fetchSitesLocationMap])
    return (
        <Layout title={localization.sitesLocationMap} isLoading={isLoading}>
            {sitesLocMapList &&
            <MapWithAMakredInfoWindow
                googleMapURL={Config.googleAPI.placeSearch}
                loadingElement={<div className="height-full" />}
                containerElement={<div className="height-full" />}
                mapElement={<div className="map-element" />}
                sitesData={sitesLocMapList}
            />}
        </Layout>
    )
}

export default SitesLocationMap;